import { inject } from 'vue'

export const useSortingInjector = () => {
  const sortingState = inject('sortingState')
  const updateSortingState = inject('updateSortingState')
  const sortingOptions = inject('sortingOptions')

  return {
    sortingState,
    updateSortingState,
    sortingOptions,
  }
}
